import React from 'react'
import AnimatePage from '../components/AnimatePage'
import Wrapper from '../helpers/Wrapper'
import SectionHead from '../components/SectionHead'
import { useQuery } from '@tanstack/react-query'
import { apiClient } from '../helpers/Axios'
import DatabaseContent from '../components/DatabaseContent'
import { Helmet } from 'react-helmet'

function Privacy() {

    const { data, status } = useQuery({
        queryKey: ['privacy-policy'],
        queryFn: async () => {
            const res = await apiClient('/shop/privacy-policy')
            return res.data
        }
    })

    return (
        <div className="mx-auto w-full max-w-7xl">
            <AnimatePage>
                <Helmet>
                    <title>Privacy Policy</title>
                </Helmet>
                <Wrapper>
                    <div className='w-full relative mt-16'>
                        <SectionHead title={"Privacy Policy"} description={"Privacy Policy"} />

                        {/* Contents */}
                        {status === 'success' && (
                            <div className="mt-10" >
                                <DatabaseContent htmlContent={data?.content} />
                            </div>
                        )}
                    </div>
                </Wrapper>
            </AnimatePage>
        </div>
    )
}

export default Privacy